import {
  Button,
  Dialog,
  Link,
  Text,
  Spacer,
  Flexbox,
  useToast
} from "@skf-internal/ui-components-react";
import { useState } from "react";
import { detachAppAdminRoleFromUser } from "./applicationDetailsAPI"


export default function RemoveAdmin(props: any) {
  const { app, user, canRemoveUsers = false, callBack, reRender } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { addToast } = useToast();

  const removeUserFromAdmin = () => {

    detachAppAdminRoleFromUser(app.applicationId, user.adminProfileId).then((res) => {
      addToast({
        children: "Admin Role removed successfully.",
        feSeverity: "success",
      });

    }).catch((error) => {
      console.log(error);
      addToast({
        children: `Something went wrong, Please try again later`,
        feSeverity: "error",
      });

    })

    setTimeout(() => {
      setIsOpen(false);
      callBack();
      reRender(true);
      reRender(false);
    }, 1000);
  };

  return (
    <div>
      {canRemoveUsers && (
        <Link
          as="button"
          feIcon={{ feIcon: "closeFault", position: "right" }}
          onClick={() => setIsOpen(true)}
          title="Remove member"
        >
          {" "}
        </Link>
      )}
      <Dialog
        {...props}
        feInterruptive
        feTitle="Remove administrative access from the user"
        open={isOpen}
        cssWidth={"40rem"}
        cssHeight={"22rem"}
      >
        <div className="globalroleadminremove">
          <Text>
            {`You are removing administrative access for ${user.adminProfile.email}, would you like to continue ?`}

          </Text>
          <Spacer feSpacing="md" />
          <Flexbox
            feGap="md"
            feJustifyContent="flex-end"
            className="modalButtons"
          >
            <Button feType="secondary" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button onClick={() => removeUserFromAdmin()}>Confirm</Button>
          </Flexbox>
        </div>
      </Dialog>
    </div>
  );
}
